import AcknowledgementBox from "./AcknowledgementBox";
import JouryDetails from "./JouryDetails";

const JouryOrAckBox = ({
  confirmFlightLocationUrl,
  detailsData,
  isBusinessTrip,
}) => {
  return confirmFlightLocationUrl ? (
    <AcknowledgementBox />
  ) : (
    <>
      <JouryDetails
        isBusinessTrip={isBusinessTrip}
        employeeJouryStatus={detailsData.status}
        companyContri={detailsData.cmpContribution}
        employeeContri={detailsData.empContribution}
        name={detailsData.assignedTo?.name}
        rejectionReason={detailsData.rejectionReason}
      />
    </>
  );
};

export default JouryOrAckBox;
